import React, { useState } from "react";
import { createContext } from "react";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import { ThirdPartyDispatch } from "../ThirdPartyList/ThirdPartyFuncs";
import List, { ListName } from "../List/List";
import { fetchData } from "../List/ListFuncs";
import { ListDefine } from "../ThirdPartyList/ThirdPartyComponent";

interface IntMortgageContext {
    fileListColumns: string[],
    listName: ListName,
    searchTable: string,
}

export const MortgageContext = createContext<IntMortgageContext>(null);

export const MortgageLender = () => {
    const listDef = ListDefine["MortgageLenderList"].Sublists;
    const showList = useAppSelector((state) => state.ThirdPartyListState === ListDefine["MortgageLenderList"].reduxShowState);
    const dispatch = useDispatch();
    const [showTabNum, setShowTabNum] = useState<number>(0);
    const handleSelect = (eventKey) => { setShowTabNum(eventKey); };

    return (
        (showList &&
            <Modal centered show={true} size="xl" className="modal-list modal-search">
                <Tabs
                    id={`MortgageLenderList-tabs`}
                    activeKey={showTabNum}
                    onSelect={handleSelect}>
                    {listDef.map((list, index) => {
                        return (
                            <Tab
                                eventKey={index}
                                title={list.label}
                                key={`${list.listName}-${index}-body`}
                                mountOnEnter={true}
                                unmountOnExit={true}>
                                <MortgageContext.Provider value={
                                    {
                                        fileListColumns: list.fileListColumns,
                                        listName: "MortgageLenderList",
                                        searchTable: list.searchTable,
                                    }
                                }>
                                    <List
                                        as={"ModalBody"}
                                        listName={list.listName}
                                        handleLoadQpickData={fetchData}
                                        ListColumns={list.fileListColumns}
                                        buildHead={list.buildHead}
                                        buildLenderListLink={list.buildListLink}
                                        searchTable={list.searchTable}
                                        sortingMethod={list.sortingMethod} />
                                </MortgageContext.Provider>
                            </Tab>
                        )
                    })}
                </Tabs>

                <Modal.Footer>
                    <Button variant="outline-primary" onClick={async () => {
                        ThirdPartyDispatch(dispatch, "MortgageLender", false);
                    }}
                    >Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    )
}
